let _locked = false;
const _listeners = new Set<(locked: boolean) => void>();

export function setCompanyLocked(v: boolean): void {
  if (_locked === v) return;
  _locked = v;
  _listeners.forEach(fn => fn(v));
}

export function getCompanyLocked(): boolean { return _locked; }

export function subscribeToCompanyLock(fn: (locked: boolean) => void): () => void {
  _listeners.add(fn);
  fn(_locked);
  return () => { _listeners.delete(fn); };
}
